import { initializeIcons } from "@uifabric/icons";

initializeIcons();



// WEBPACK FOOTER //
// ./src/fabric/icons.tsx